module.exports = __webpack_public_path__ + "static/media/image_9.025bded1.svg";